import { useState, useEffect } from "react";

const Timer = ({ OrderCreateAt, H, timeAnnounce }) => {
    const [days, setDays] = useState(0);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    const createTime = new Date(OrderCreateAt).getTime();
    const updatedTime = createTime + H * 60 * 60 * 1000;

    useEffect(() => {
        const getTime = () => {
            const time = updatedTime - Date.now();
            setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
            setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
            setMinutes(Math.floor((time / 1000 / 60) % 60));
            setSeconds(Math.floor((time / 1000) % 60));
        };
        const interval = setInterval(getTime, 1000);
        return () => clearInterval(interval);
    }, [updatedTime]);

    return (
        <>
            {days + hours + minutes + seconds > 0 ?
                <p className="c-darkOrange">
                    {days < 10 ? "0" + days : days}:
                    {hours < 10 ? "0" + hours : hours}:
                    {minutes < 10 ? "0" + minutes : minutes}:
                    {seconds < 10 ? "0" + seconds : seconds}
                </p>
                : <p className="text-warning m-0">
                    {timeAnnounce}
                </p>}
        </>
    );
};
export default Timer;
